import axios from 'axios';
import { AppException } from './exception';

const authApi = axios.create({
    baseURL: process.env.VUE_APP_CDN_PATH !== 'prod' ? 'https://la-test-ad-service.aiyouaiyou.cn' : '//la-ad-service.aiyouaiyou.cn',
    headers: {
        'Content-Type': 'application/octet-stream',
    },
});

const fileApi = axios.create({
});

const fileToBuffer = (file: File) => {
    return new Promise<FileReader>(resolve => {
        const reader = new FileReader();
        reader.onload = () => {
            resolve(reader);
        };
        reader.readAsArrayBuffer(file);
    });
};

/**
 * 文件上传通用逻辑
 * @param files 需要的文件对象
 */
export const fileUploader = async (files: Array<File>) => {
    return Promise.all(files.map(async file => {
        try {
            const formData = new FormData();
            formData.set('file', file);
            const authRes = await authApi.post(`/api/file/signurl?name=${PACKAGE_NAME}&fileName=${file.name}`, formData);
            if (authRes.status !== 200 || authRes.data?.status !== 200) {
                throw new AppException(authRes.data?.message || '文件上传失败');
            }
            const data = await fileToBuffer(file);
            await fileApi.put(authRes.data.data?.uploadUrl, data.result, {
                headers: {
                    'Content-Type': file.type,
                },
            });
            return authRes.data.data?.cname;
        } catch(e) {
            throw new AppException((e as Error).message || '文件上传失败');
        }
    }));
};
